import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
export var NotBrandNorRetailerMessage = function NotBrandNorRetailerMessage(_ref) {
  var visible = _ref.visible;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "RTbSpK",
    defaultMessage: [{
      "type": 0,
      "value": "Se é uma marca ou um revendedor, escolha uma das opções acima para receber uma resposta no prazo de 24 horas. Se não é uma marca ou um revendedor, envie-nos um e-mail para external-requests@faire.com."
    }]
  }));
};